import { createContext, useContext, useState } from "react";

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [expandedClients, setExpandedClients] = useState({});

  return (
    <NavbarContext.Provider value={{ expandedClients, setExpandedClients }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbarContext = () => useContext(NavbarContext);
